module.exports = __webpack_public_path__ + "img/Agendamentos.cee4c166.png";